import { mapScheduleToTRPC } from '@risksmart-app/trpc/src/types';
import type { InsertIndicatorMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertIndicatorDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { FrontendRouterInputs } from '../routerInputs';
import type { InsertIndicatorInput } from '../scheduledEntityInputs';

type InsertIndicatorTRPCInput = FrontendRouterInputs['indicator']['insert'];

export const useInsertIndicator = createMutationHook({
  name: 'insertIndicator',
  isIdempotentCreate: true,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.indicator.insert.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: ({
    schedule,
    ...rest
  }: InsertIndicatorInput): InsertIndicatorTRPCInput => ({
    ...rest,
    ...mapScheduleToTRPC(schedule),
  }),
  invalidate: (trpc) => [
    trpc.frontend.indicator.register.queryKey(),
    trpc.frontend.indicator.indicatorsByParentId.queryKey(),
    trpc.frontend.control.register.queryKey(),
    trpc.frontend.risk.register.queryKey(),
    // COI-889: the my-items ribbon counts this entity.
    trpc.frontend.myItems.pathKey(),
  ],
  mapResponse: (result: { Id: string }): InsertIndicatorMutation => ({
    insertChildIndicator: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertIndicatorDocument,
  graphqlVariables: (input: InsertIndicatorInput) => ({ object: input }),
  evictFields: ['control', 'risk'],
});
